import { extractProperty } from "./extractProperty"

export function getBrands({ brands }: { brands: any }) {
  const brandsUmbraco =
    (brands.components?.edges?.map((el: any) => {
      const object = el.node
      const brandName = extractProperty(object, "brandName")
      const media = extractProperty(object, "media")
      const brandIcon = extractProperty(object, "brandIcon")

      return {
        title: brandName,
        logo: brandIcon,
        image: media,
        url: object?.url,
      }
    }) as {
      image: string
      title: string
      logo: string
      url: string
    }[]) || []
  return brandsUmbraco
}
